<template>
    <div :class="isMobile?'noticeB':'notice'">
        <div class="noticeTab" :class="isMobile?'font16':'font18'">
            <div :class="active==106101?'noticeA':'noticeM'" @click="noticeC(106101)">通知公告</div>
            <div :class="active==106102?'noticeA':'noticeM'" @click="noticeC(106102)">协会工作</div>
            <div :class="active==106103?'noticeA':'noticeM'" @click="noticeC(106103)">行业动态</div>
            <div class="more" @click="lookMore">更多&gt;</div>
        </div>
        <div class="noticeCont">
            <div class="clearfix mt12" v-for="(item,index) in noticeList" :key="index" @click="lookInfo(item.NewsGuid)">
                <span class="point fl"></span>
                <span class="fl overh titlebox" :class="item.chaTime<10?'titleNew':''">{{item.Title}}</span>
                <span class="fr c99 font14">{{item.AddTime | timeChange}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                active:106101,
                noticeList:[],
                total:20,
                form:{
                    cataCode:106101,
                    pageIndex:1,
                    pageSize:9
                }
            }
        },
        methods:{
            noticeC(type){
                this.active = type
                this.form.cataCode = type
                this.form.pageIndex= 1
                this.getListData()
            },
            //获取列表数据
            getListData(){
                this.Request({
                    url: '/api/NewsData/GetNewsDataTwo',
                    method: 'get',
                    data:{
                        ...this.form
                    }
                }).then((data) => {
                    var list = data.Data
                    var nowTime = new Date().getTime()
                    for(var i=0;i<list.length;i++){
                        list[i].time = new Date(list[i].AddTime.split('T')[0]+' 00:00:00').getTime()
                        var chaTime = (nowTime - list[i].time)/86400000
                        list[i].chaTime = chaTime
                    }
                   this.total = data.TotalSum
                   this.noticeList = list
                })
            },

            //查看详情
            lookInfo(id){
                this.$router.push({
                    path:'/notice/info?id='+id+'&type='+this.active
                })
            },
            //查看更多
            lookMore(){
                this.$router.push({
                    path:'/notice?type='+this.active
                })
            },
        },
        mounted(){
            this.getListData()
        }
    }
</script>

<style scoped>
    .notice{
        width: 690px;
        height: 400px;
        background: #fff;
        border-radius: 3px;
    }
    .noticeB{
        width: 100%;
        margin-top: 20px;
        background: #fff;
        padding-bottom: 20px;
    }
    .noticeTab{
        display: flex;
        justify-content: flex-start;
        padding: 0 15px;
        padding-bottom: 0;
        position: relative;
        border-bottom: 1px solid #DFDFDF;
    }
    .more{
        position: absolute;
        top: 15px;
        right: 15px;
        z-index: 10;
        cursor: pointer;
        color: #969696;
    }
    .noticeA{
        color: #fff;
        border-bottom: 3px solid #0D69F0;
        background-color: #0D69F0;
        padding: 15px;
        padding-bottom: 10px;
        margin-right: 10px;
        cursor: pointer;
        font-weight: bold;
    }
    .noticeM{
        padding: 15px;
        padding-bottom: 10px;
        margin-right: 10px;
        cursor: pointer;
        padding-top: 15px;
    }
    .noticeCont{
        padding:0 15px;
    }
    .point{
        width: 5px;
        height: 5px;
        background-color: #0D69F0;
        border-radius: 50%;
        margin-top: 10px;
        margin-right: 5px;
    }
    .titlebox{
        width: calc(100% - 115px);
        cursor: pointer;
        font-size: 17px;
    }
    .titlebox:hover{
        color: #0D69F0;
    }
    .titlebox:active{
        color: #999;
    }
    .titleNew{
        position: relative;
        padding-right: 50px;
    }
    .titleNew::after{
        position: absolute;
        content: 'NEW!';
        color: red;
        font-weight: bold;
        font-size: 12px;
        right: 0;
        top: 0;
    }
</style>